import {
  apiClient,
  type PageEntity,
  type ShipmentOrderImportJobExEntity
} from '@/libs/api'
import { type ShipmentOrderImportJobsRequestQuery } from '@/libs/api/types'

export type FetchShipmentOrderImportJobsQuery = {
  tenantKey: string
  query: ShipmentOrderImportJobsRequestQuery
}

export type FetchShipmentOrderImportJobsResponse = {
  data: ShipmentOrderImportJobExEntity[]
  pagination: PageEntity | null
}

export const fetchShipmentOrderImportJobs = async (
  { tenantKey, query }: FetchShipmentOrderImportJobsQuery,
  signal?: AbortSignal
): Promise<FetchShipmentOrderImportJobsResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .shipment_order_import_jobs.$get({
      query,
      config: {
        signal
      }
    })
  return {
    data,
    pagination
  }
}
